<p-tabs
  [(value)]="selectedMainTabIndex"
  (valueChange)="onMainTabChange($event)"
>
  <div class="scroll-container">
    <p-tablist>
      <p-tab [value]="0">Missing Shares Info
        <span *ngIf="alerts.at(0)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(0)?.entriesAdded }}</span>
      </p-tab>
      <p-tab [value]="1">Transaction Tag
        <span *ngIf="alerts.at(1)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(1)?.entriesAdded }}</span>
      </p-tab>
      <p-tab [value]="2">Transaction Type Other
        <span *ngIf="alerts.at(2)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(2)?.entriesAdded }}</span>
      </p-tab>
      <p-tab [value]="3">Transaction Type Buy
        <span *ngIf="alerts.at(3)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(3)?.entriesAdded }}</span>
      </p-tab>
      <p-tab [value]="4">Missing Security Breakdown
        <span *ngIf="alerts.at(4)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(4)?.entriesAdded }}</span>
      </p-tab>
      <p-tab [value]="5">Aggregate Shares Validation
        <span *ngIf="alerts.at(5)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(5)?.entriesAdded }}</span>
      </p-tab>
      <p-tab [value]="6">Duplicate Filings
        <span *ngIf="alerts.at(6)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(6)?.entriesAdded }}</span>
      </p-tab>
      <p-tab [value]="7">Check Plan Action
        <span *ngIf="alerts.at(7)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(7)?.entriesAdded }}</span>
      </p-tab>
      <p-tab [value]="8">Missing Adoption Date
        <span *ngIf="alerts.at(8)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(8)?.entriesAdded }}</span>
      </p-tab>
      <p-tab [value]="9">Null Transaction Type
        <span *ngIf="alerts.at(9)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(9)?.entriesAdded }}</span>
      </p-tab>
      <p-tab [value]="10">Null Security Type
        <span *ngIf="alerts.at(10)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(10)?.entriesAdded }}</span>
      </p-tab>
      <p-tab [value]="11">Non Individual Relationship to Issuer
        <span *ngIf="alerts.at(11)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(11)?.entriesAdded }}</span>
      </p-tab>
      <p-tab [value]="12">Effective date < Adoption date
        <span *ngIf="alerts.at(12)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(12)?.entriesAdded }}</span>
      </p-tab>
      <p-tab [value]="13"
      >Expiration date < Adoption date / Effective date
        <span *ngIf="alerts.at(13)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(13)?.entriesAdded }}</span>
      </p-tab
      >
      <p-tab [value]="14">Termination date < Adoption date
        <span *ngIf="alerts.at(14)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(14)?.entriesAdded }}</span>
      </p-tab>
      <p-tab [value]="15">Expiration date < Termination date
        <span *ngIf="alerts.at(15)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(15)?.entriesAdded }}</span>
      </p-tab>
      <p-tab [value]="16">Amendment date <= Adoption date
        <span *ngIf="alerts.at(16)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(16)?.entriesAdded }}</span>
      </p-tab>
      <p-tab [value]="17">Expiration date & Duration days null
        <span *ngIf="alerts.at(17)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(17)?.entriesAdded }}</span>
      </p-tab>
      <p-tab [value]="18">Insider Null
        <span *ngIf="alerts.at(18)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(18)?.entriesAdded }}</span>
      </p-tab>
      <p-tab [value]="19">Duplicate Plans
        <span *ngIf="alerts.at(19)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(19)?.entriesAdded }}</span>
      </p-tab>
      <p-tab [value]="20">Plan Linkage
        <span *ngIf="alerts.at(20)?.entriesAdded ?? 0 > 0" class="badge">{{ alerts.at(20)?.entriesAdded }}</span>
      </p-tab>
    </p-tablist>
  </div>

  <p-tabpanels>
    <p-tabpanel [value]="0">
      <ng-container *ngIf="selectedMainTabIndex === 0">
        <app-missing-shares-info [isActive]="true"></app-missing-shares-info>
      </ng-container>
    </p-tabpanel>

    <p-tabpanel [value]="1">
      <ng-container *ngIf="selectedMainTabIndex === 1">
        <app-security-type-flags [isActive]="true"></app-security-type-flags>
      </ng-container>
    </p-tabpanel>

    <p-tabpanel [value]="2">
      <ng-container *ngIf="selectedMainTabIndex === 2">
        <app-transaction-type-other
          [isActive]="true"
        ></app-transaction-type-other>
      </ng-container>
    </p-tabpanel>

    <p-tabpanel [value]="3">
      <ng-container *ngIf="selectedMainTabIndex === 3">
        <app-transaction-type-buy [isActive]="true"></app-transaction-type-buy>
      </ng-container>
    </p-tabpanel>

    <p-tabpanel [value]="4">
      <ng-container *ngIf="selectedMainTabIndex === 4">
        <app-missing-security-breakdown
          [isActive]="true"
        ></app-missing-security-breakdown>
      </ng-container>
    </p-tabpanel>

    <p-tabpanel [value]="5">
      <ng-container *ngIf="selectedMainTabIndex === 5">
        <app-aggregate-shares-validation
          [isActive]="true"
        ></app-aggregate-shares-validation>
      </ng-container>
    </p-tabpanel>
    <p-tabpanel [value]="6">
      <ng-container *ngIf="selectedMainTabIndex === 6">
        <app-duplicate-filings [isActive]="true"></app-duplicate-filings>
      </ng-container>
    </p-tabpanel>
    <p-tabpanel [value]="7">
      <ng-container *ngIf="selectedMainTabIndex === 7">
        <app-check-plan-action [isActive]="true"></app-check-plan-action>
      </ng-container>
    </p-tabpanel>
    <p-tabpanel [value]="8">
      <ng-container *ngIf="selectedMainTabIndex === 8">
        <app-missing-date-adoption
          [isActive]="true"
        ></app-missing-date-adoption>
      </ng-container>
    </p-tabpanel>
    <p-tabpanel [value]="9">
      <ng-container *ngIf="selectedMainTabIndex === 9">
        <app-null-transaction-type
          [isActive]="true"
        ></app-null-transaction-type>
      </ng-container>
    </p-tabpanel>
    <p-tabpanel [value]="10">
      <ng-container *ngIf="selectedMainTabIndex === 10">
        <app-null-security-type [isActive]="true"></app-null-security-type>
      </ng-container>
    </p-tabpanel>
    <p-tabpanel [value]="11">
      <ng-container *ngIf="selectedMainTabIndex === 11">
        <app-non-individual-relationship
          [isActive]="true"
        ></app-non-individual-relationship>
      </ng-container>
    </p-tabpanel>
    <p-tabpanel [value]="12">
      <ng-container *ngIf="selectedMainTabIndex === 12">
        <app-effective-date-adoption-date
          [isActive]="true"
        ></app-effective-date-adoption-date>
      </ng-container>
    </p-tabpanel>
    <p-tabpanel [value]="13">
      <ng-container *ngIf="selectedMainTabIndex === 13">
        <app-expiration-date-adoption-date
          [isActive]="true"
        ></app-expiration-date-adoption-date>
      </ng-container>
    </p-tabpanel>
    <p-tabpanel [value]="14">
      <ng-container *ngIf="selectedMainTabIndex === 14">
        <app-termination-date-adoption-date
          [isActive]="true"
        ></app-termination-date-adoption-date>
      </ng-container>
    </p-tabpanel>

    <p-tabpanel [value]="15">
      <ng-container *ngIf="selectedMainTabIndex === 15">
        <app-expiration-date-termination-date
          [isActive]="true"
        ></app-expiration-date-termination-date>
      </ng-container>
    </p-tabpanel>
    <p-tabpanel [value]="16">
      <ng-container *ngIf="selectedMainTabIndex === 16">
        <app-adoption-date-amendment-date
          [isActive]="true"
        ></app-adoption-date-amendment-date>
      </ng-container>
    </p-tabpanel>
    <p-tabpanel [value]="17">
      <ng-container *ngIf="selectedMainTabIndex === 17">
        <app-expiration-date-duration-days-null
          [isActive]="true"
        ></app-expiration-date-duration-days-null>
      </ng-container>
    </p-tabpanel>
    <p-tabpanel [value]="18">
      <ng-container *ngIf="selectedMainTabIndex === 18">
        <app-insider-null [isActive]="true"></app-insider-null>
      </ng-container>
    </p-tabpanel>
    <p-tabpanel [value]="19">
      <ng-container *ngIf="selectedMainTabIndex === 19">
        <app-duplicate-plans [isActive]="true"></app-duplicate-plans>
      </ng-container>
    </p-tabpanel>

    <p-tabpanel [value]="20">
      <ng-container *ngIf="selectedMainTabIndex === 20">
        <app-plan-linkage [isActive]="true"></app-plan-linkage>
      </ng-container>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
